import { mapState } from 'vuex'

export default {
  data() {
    return {
      sliderServiceIcons: {
        slidesPerView: 'auto',
        speed: 700,
        loop: true,
        autoplay: {
          delay: 5000,
        },
        pagination: {
          el: '.js-icons-pag',
          clickable: true,
        },
      },
    }
  },
  computed: {
    ...mapState('mobile', ['isMobile']),
  },
  methods: {},
}



// WEBPACK FOOTER //
// ./src/templates/components/ui-components/builder/icon-block/component.js